import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Login from "./views/login/index";
import Auth from "./views/Auth/index";
import Register from "./views/register/index";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./views/dashboard/index";
import Search from "./views/search/index";
import SearchOd from "./views/searchOd";
import ControlRutas from "./views/controlRutas";
import { DataProvider } from "./contexts/DataContext";
import RegisterUser from "./views/registerUser";
import WorkOrder from "./views/workOrder";
import Report from "./views/Report";
import AdminOd from "./views/AdminOd";
import SearchOdPublic from "./views/searchOdPublic";
import AdminUploadDocuments from "./views/AdminUploadDocuments";
import ClientDocuments from "./views/ClientDocuments";
import AdminClients from "./views/AdminClients";

const Home = (): any => (
  <h1 className="text-3xl font-bold underline">Hello world!</h1>
);
const SearchPage = (): any => <h1> Search</h1>;

function App() {
  return (
    <DataProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Auth />}>
            <Route index element={<Login />} />
            <Route index path="register" element={<Register />} />
            <Route index path="odSearch" element={<SearchOdPublic />} />
          </Route>
          <Route path="workOrder" element={<WorkOrder />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="search" element={<Search />} />
          <Route path="searchOD" element={<SearchOd />} />
          <Route path="controlRutas" element={<ControlRutas />} />
          <Route path="RegisterUser" element={<RegisterUser />} />
          <Route path="Reporte" element={<Report />} />
          <Route path="AdminOd" element={<AdminOd />} />
          <Route path="adminUpload" element={<AdminUploadDocuments />} />
          <Route path="clientDocuments" element={<ClientDocuments />} />
          <Route path="adminClients" element={<AdminClients />} />
          <Route path="*" element={<div>404</div>} />
        </Routes>
      </div>
    </DataProvider>
  );
}

export default App;
